import Collapse from "@mui/material/Collapse"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

// SectionCard-style white card with a clickable header that expands/collapses
// its body. Controlled: pass `open` and `onToggle` from the parent.
const CollapsibleCard = ({ title, subtitle, icon, open, onToggle, children, mb = 3 }) => (
  <MDBox bgColor="white" borderRadius="lg" shadow="sm" mb={mb} overflow="hidden">
    <MDBox
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={3}
      pb={open ? 2 : 3}
      sx={{ cursor: "pointer" }}
      onClick={onToggle}
    >
      <MDBox display="flex" alignItems="center" gap={1.5}>
        {icon && (
          <MDBox
            width="2.5rem"
            height="2.5rem"
            borderRadius="50%"
            bgColor="info"
            color="white"
            display="flex"
            alignItems="center"
            justifyContent="center"
            shadow="md"
          >
            <Icon fontSize="small">{icon}</Icon>
          </MDBox>
        )}
        <MDBox>
          {title && (
            <MDTypography variant="h6" fontWeight="bold">
              {title}
            </MDTypography>
          )}
          {subtitle && (
            <MDTypography variant="caption" color="text">
              {subtitle}
            </MDTypography>
          )}
        </MDBox>
      </MDBox>
      <Icon
        sx={{
          color: "text.secondary",
          transition: "transform 200ms ease",
          transform: open ? "rotate(180deg)" : "none",
        }}
      >
        expand_more
      </Icon>
    </MDBox>
    <Collapse in={open}>
      <MDBox px={3} pb={3}>
        {children}
      </MDBox>
    </Collapse>
  </MDBox>
)

export default CollapsibleCard
